import React from 'react';

import Highlight from '@components/FeedItems/Highlight';
import { briefing_feed_path } from '@routes';

interface HeadlineProps {
  headline: string;
}

const Headline = ({ headline }: HeadlineProps) => (
  <header>
    <Highlight
      highlight="Briefing"
      customPath={briefing_feed_path()}
      className="!text-caption-md"
    />
    <h1 className="text-grayscale-black mb-0 mt-8 max-w-[884px] text-pretty font-suisse-works text-headline-md">
      {headline}
    </h1>
  </header>
);

export default Headline;
